import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayNumber from './DisplayNumber';
import EditNumber from './EditNumber';

const NumberInputContainer = ({
    initialValue: onPageLoadValue,
    syncChanges,
    isEditing,
    setIsEditing,
    isHovered,
    isCurrency,
    isInt,
    isPercentage,
}) => {
    const [value, setValue] = useState(onPageLoadValue !== undefined ? onPageLoadValue : null);
    const [initialValue, setInitialValue] = useState(onPageLoadValue !== undefined ? onPageLoadValue : null);
    const isFieldNull = value === null;

    useEffect(() => {
        setValue(onPageLoadValue !== undefined ? onPageLoadValue : null);
        setInitialValue(onPageLoadValue !== undefined ? onPageLoadValue : null);
    }, [onPageLoadValue]);

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        if (value !== null) {
            if (isNaN(value)) {
                return { success: false, message: 'Måste vara ett tal.' };
            } else if (isInt && parseInt(value) !== value) {
                return { success: false, message: 'Måste vara ett heltal.' };
            } else if (isPercentage && (value < 0 || value > 100)) {
                return { success: false, message: 'Måste vara mellan 0 och 100.' };
            }
        }
        const response = await syncChanges(value);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayNumber {...{ value, isCurrency }} />
            <EditNumber {...{ value, setValue, isCurrency }} />
        </GenericInputContainer>
    );
};

export default NumberInputContainer;
